define('modules/editor/models/property_groups/button_geometry',['require','exports','module','./geometry'],function(require, exports, module){
  "use strict";
  var Geometry = require("./geometry");
  module.exports = Geometry.extend({
    name: "button:geometry",
    generateStyles: function($el, id){
      return [
        {
          selector: "#" + id,
          rules: {
            "top": this.get("top") + "px",
            "left": this.get("left") + "px"
          }
        },
        {
          selector: "#" + id +  " a.btn",
          rules: {
            "width": this.get("width") + "px",
            "height": this.get("height") + "px",
            "line-height": this.get("height") + "px"
          }
        }
      ];
    }
  });
});
